module.exports = __webpack_public_path__ + "static/media/TMCLogo@3x.5ee6f91f.png";